import Vue from 'vue'
import VueI18n from 'vue-i18n'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import zhElement from './zh'
import enElement from './en'
// import Cookies from 'js-cookie'

Vue.use(VueI18n)

const messages = {
  // 将enLocale、enElement里面的内容合道一起
  en: {
    ...enLocale,
    ...enElement
  },
  zh: {
    ...zhLocale,
    ...zhElement
  }
}

const i18n = new VueI18n({
  // vue-i18n提供了一个全局配置参数叫 “locale”，通过改变 locale 的值可以实现不同语种的切换
  // 首先选择本地支持的语言
  // locale: Cookies.get('language') || 'en',
  locale: 'zh',
  messages
})
export default i18n



// WEBPACK FOOTER //
// ./src/common/lang/index.js